import { Controller } from 'stimulus'
import { setModalLinkUrl } from '../../utils/modal_link'

export default class extends Controller {
  static targets = [
    'postcode',
    'addressLine1',
    'addressLine2',
    'addressLine3',
    'addressLine4',
    'applicantName',
    'applicantCompany',
    'conflictCheckLinkModal'
  ]
  static values = { valuationId: Number }

  connect () {
    setModalLinkUrl(this.conflictCheckLinkModalTarget, this.conflictCheckUrlWithArguments('modal'))
  }

  updateArguments() {
    setModalLinkUrl(this.conflictCheckLinkModalTarget, this.conflictCheckUrlWithArguments('modal'))
  }

  conflictCheckUrlWithArguments(format) {
    let url = `${this.conflictCheckUrl}.${format}?postcode=${this.postcode}&address=${encodeURIComponent(this.address)}&applicant_name=${this.applicantName}&applicant_company=${this.applicantCompany}`
    const id = this.valuationIdValue
    if (id !== 'new') {
      url += `&id=${id}`
    }
    return url
  }

  get conflictCheckUrl() {
    return this.postcodeTarget.dataset.url
  }

  get postcode() {
    return this.postcodeTarget.value
  }

  get applicantName() {
    return this.applicantNameTarget.value
  }

  get applicantCompany() {
    return this.applicantCompanyTarget.value
  }

  get address() {
    return [
      this.addressLine1Target.value,
      this.addressLine2Target.value,
      this.addressLine3Target.value,
      this.addressLine4Target.value
    ].filter(x => x != null && x !== '').join(' ')
  }
}
